module.exports = __webpack_public_path__ + "img/nakladnoy_logo_name.34e87742.jpg";